"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollapseHtmlWithInfoIconWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
/**
 * Widget to render some html like label or header with Info icon in the right side (props -> header)
 * And collapsed html content (props -> content)
 */
var CollapseHtmlWithInfoIconWidget = /** @class */ (function (_super) {
    __extends(CollapseHtmlWithInfoIconWidget, _super);
    function CollapseHtmlWithInfoIconWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.sendState = function () {
            _this.props.parentCallback(!_this.state.showInfo);
        };
        _this.showInfoHandler = _this.showInfoHandler.bind(_this);
        _this.sendState = _this.sendState.bind(_this);
        _this.state = {
            showInfo: false
        };
        return _this;
    }
    CollapseHtmlWithInfoIconWidget.prototype.render = function () {
        return ((0, jsx_runtime_1.jsxs)("div", { className: "widget collapse-label-widget", children: [(0, jsx_runtime_1.jsx)("div", { className: "media pt-3", onClick: this.showInfoHandler, children: (0, jsx_runtime_1.jsx)("div", { className: "label-body", children: (0, jsx_runtime_1.jsxs)("label", { className: "no-wrap-label", children: [(0, jsx_runtime_1.jsx)("span", { className: "whitespace-normal-span", children: this.props.header }), "\u00A0", (0, jsx_runtime_1.jsx)("span", { className: "info-button-container", children: (0, jsx_runtime_1.jsx)("button", { tabIndex: 0, type: "button", className: this.state.showInfo ? "info-button selected" : "info-button", "aria-label": this.props.title, onClick: this.showInfoHandler }) })] }) }) }), (0, jsx_runtime_1.jsx)("div", { className: this.state.showInfo ? "d-block" : "d-none", children: this.props.content })] }));
    };
    CollapseHtmlWithInfoIconWidget.prototype.showInfoHandler = function () {
        this.sendState();
        this.setState({
            showInfo: !this.state.showInfo
        });
    };
    return CollapseHtmlWithInfoIconWidget;
}(React.Component));
exports.CollapseHtmlWithInfoIconWidget = CollapseHtmlWithInfoIconWidget;
//# sourceMappingURL=CollapseHtmlWithInfoIconWidget.js.map